<template>
	<ppe-form 
		entityName="D3"
	  title="D3. Livret d'Accueil Prévention EU"
		title-field="{operation.code}, {operation.operationname}"
 	  sub-title=""

		:schema="schema" 
		:endpoint="endpoint"
		:redirect="'/ppe_eu/operation_home/:operationid'" 
		v-on:dataLoaded="onDataLoaded"
		>

	</ppe-form>
</template>
<script>
 
import Business from 'ppe-business'
import Utils    from '../ppe/utils'

export default {
	data() {
		var self = this;
		console.log("this.$route.params.operationid", this.$route.params.operationid)
		return {
			endpoint : "/eu/d3?id="+this.$route.params.id+"&operationid="+this.$route.query.operationid,
			dangers: {},
			schema : [
				{ card:"Analyse des dangers et des risques récurrents", 
				  id:'risks',
					body:[
						{name:"reccurrentDangers",       label:'',         type:"checkboxtable", displayIndex:true,  size:'large',
								columns: ['#','', 'RISQUES RECURRENTS','CAUSES / CONSEQUENCES POTENTIELLES','MESURES DE PRÉVENTION'],
								options:Business.reccurrentDangers,
						},
						{component:'h5', children:"Nouveaux risques générés ponctuellement liés à la spécificité de l'opération", size:"large"},
						{
							type:'group', repeatable: true,
							name: 'ponctualRisks', label : 'Identification des risques',
							addLabel: 'Ajouter un risque', validation : "min:0,length", size: 'large',
							children:[
									{ component: 'div', class:'display-inline', children:[
										{name:"description",   			label:"Identification des risques",     type: "textarea",  validation: '', class:'col-md-4'},
										{name:"consequences",  			label:"Causes / conséquences",          type: "textarea",  validation: '', class:'col-md-4'},
										{name:"prevention",   			label:"Mesures de prévention",          type: "textarea",  validation: '', class:'col-md-4'},
									]},
							]
						},
					],
				}, 
				
				Utils.getGetManagerCard(),
				Utils.getAdminCard(),
				
				],
		}
	},
	methods : {
		ParentHasDanger(danger) {
			console.log("ParentHasDanger", danger, this.dangers)
			//return this.reccurrentDangersParent && this.reccurrentDangersParent.includes(danger) ? ["☑"]:["☐"]

			return this.dangers ? this.dangers[danger] : ''
		},
		onDataLoaded(data) {
			return; // DO NOTHING ist an EU
			// Do not add columns and checboxes beacause the entities are same
			if(!data.parentD3 || data.parentD3.id === data.entity.id) return
			//Add the E.U. column to compare with the EU checkboxes
			let risks = this.schema.find( e => e.id==='risks')
			
			for(var opt of risks.body[0].options) {
				opt.prefixValues = ['☐']
			}
			for(var d of data.parentD3.reccurrentDangers) {
				let opt = risks.body[0].options.find( o => o.value===d)
				opt.prefixValues = ['☑'] // 
			}

			risks.body[0].columns.splice(1, 0, 'E.U.')

			console.log("this.dangers", this.dangers)
			this.schema = [...this.schema, undefined]
		}
	}
};
</script>
<style>
.display-inline {
	display:   flex;
	flex-wrap: wrap;
}

.formulate-input-element-checkboxtable .formulate-input-label {
	/*white-space:nowrap;*/
	min-width: 40%;
}
</style>
